import React, { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
	FileText,
	Radio,
	Inbox,
	BookmarkCheck,
	BadgeCheck,
	CalendarDays,
	ClipboardCheck,
	ArrowRight,
	UserCheck,
	FileBadge,
	UserPlus,
	UserX,
	Undo2,
	PauseCircle,
	ShieldCheck,
} from "lucide-react";

import { GetDashBoardData } from "../Services/DashboardService";

const EmployeeDashboard = () => {
	const navigate = useNavigate();

	const [data, setData] = useState({
		createdJob: 0,
		publishedJob: 0,
		incomingApplication: 0,
		shortlisted: 0,
		interviewScheduled: 0,
		assessment: 0,
		selected: 0,
		offerRelesed: 0,
		hired: 0,
		rejected: 0,
		hold: 0,
		bgv: 0,
		backout: 0,
	});

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchDashboard = async () => {
			try {
				const res = await GetDashBoardData();
				const count = res.data.dashboardData[0];
				setData((prev) => ({ ...prev, ...count }));
			} catch (err) {
				console.log(err);
			} finally {
				setLoading(false);
			}
		};

		fetchDashboard();
	}, []);

	const steps = [
		{
			title: "Draft Jobs",
			count: data.createdJob,
			link: "/HRSetu/Dashboard/Draft-Jobs",
			icon: FileText,
		},
		{
			title: "Live Jobs",
			count: data.publishedJob,
			link: "/HRSetu/Dashboard/Live-Jobs",
			icon: Radio,
		},
		{
			title: "Applications",
			count: data.incomingApplication,
			link: "/HRSetu/Dashboard/New-Applications",
			icon: Inbox,
		},
		{
			title: "Shortlisted",
			count: data.shortlisted,
			link: "/HRSetu/Dashboard/Shortlist-Candidates",
			icon: BookmarkCheck,
		},
		{
			title: "Interviews",
			count: data.interviewScheduled,
			link: "/HRSetu/Dashboard/Interview-Scheduled",
			icon: CalendarDays,
		},
		{
			title: "Assessments",
			count: data.assessment,
			link: "/HRSetu/Dashboard/Assessment-Candidates",
			icon: ClipboardCheck,
		},
		{
			title: "Selected",
			count: data.selected,
			link: "/HRSetu/Dashboard/Get-Selected-Candidates",
			icon: UserCheck,
		},
		{
			title: "Offer Released",
			count: data.offerRelesed,
			link: "/HRSetu/Dashboard/Offer-Released-Candidate",
			icon: FileBadge,
		},
		{
			title: "Hired",
			count: data.hired,
			link: "/HRSetu/Dashboard/Hired-Candidates",
			icon: UserPlus,
		},
		{
			title: "Rejected",
			count: data.rejected,
			link: "/HRSetu/Dashboard/Rejected-Candidates",
			icon: UserX,
		},
		{
			title: "Backout",
			count: data.backout,
			link: "/HRSetu/Dashboard/Backout-Candidates",
			icon: Undo2,
		},
		{
			title: "Hold",
			count: data.hold,
			link: "/HRSetu/Dashboard/Hold-Candidates",
			icon: PauseCircle,
		},
		{
			title: "Background Verification",
			count: data.bgv,
			link: "/HRSetu/Dashboard/BGV-Candidates",
			icon: ShieldCheck,
		},
	];

	return (
		<div className="w-full min-h-screen bg-[#f3f7fb] flex justify-center pt-32 px-6">
			<div className="max-w-[1400px] w-full">
				{loading ? (
					<SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
						<div className="grid grid-cols-4 gap-x-20 gap-y-16">
							{[...Array(8)].map((_, i) => (
								<div key={i} className="w-[220px] mx-auto">
									<Skeleton height={80} borderRadius={12} />
									<Skeleton height={20} className="mt-2" borderRadius={12} />
								</div>
							))}
						</div>
					</SkeletonTheme>
				) : (
					<div className="grid grid-cols-5 gap-x-8 gap-y-12 justify-items-center">
						{steps.map((step, i) => (
							<a
								key={i}
								href={step.link}
								className="group w-[220px] bg-white rounded-b-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
								style={{ cursor: step.link ? "pointer" : "default" }}
							>
								{/* Header */}

								<div className="bg-gradient-to-br from-[#0d47a1] to-[#42a5f5] text-white h-[110px] px-4 rounded-b-xl flex justify-between items-center">
									{/* Left (Title + Count) */}
									<div className="flex flex-col">
										<div className="text-[16px] font-medium">{step.title}</div>

										<div className="text-[26px] font-bold mt-1">
											{step.count}
										</div>
									</div>

									{/* Right Icon */}
									<div className="bg-white rounded-full w-12 h-12 flex items-center justify-center text-blue-700">
										{step.icon && <step.icon size={22} />}
									</div>
								</div>

								{/* Bottom Arrow Section */}

								<div className="flex justify-end px-4 py-3 bg-white rounded-b-xl">
									<ArrowRight className="text-blue-600" size={20} />
								</div>
							</a>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default EmployeeDashboard;
